import { Tooltip } from 'vopay';

type MetricTooltipProps = {
  information: string;
};

// The ⓘ icon shown beside Enhanced-tier metric labels — the inbuilt Tooltip,
// sized down to sit alongside 12px metric label text
export default function MetricTooltip({ information }: MetricTooltipProps) {
  return <Tooltip information={information} icon="info" variant="outlined" iconWidth="12px" buttonWidth="18px" />;
}
